enum EPaymentMethod {
  CREDIT_CARD = 'CreditCard',
  ONLINE_BANKING = 'OnlineBanking',
  BANK_TRANSFER = 'BankTransfer',
  PAY_PAL = 'PayPal',
  SBP = 'SBP',
}

export default EPaymentMethod;
